'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.CodeEditorLanguages = void 0;
(function(CodeEditorLanguages) {
    CodeEditorLanguages["Css"] = 'css';
    CodeEditorLanguages["Html"] = 'markup';
    CodeEditorLanguages["Javascript"] = 'js';
})(exports.CodeEditorLanguages || (exports.CodeEditorLanguages = {}));
//# sourceMappingURL=code-editor.js.map
